import { ComponentProps } from 'react';

export function DesignIcon(props: ComponentProps<'svg'>) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none" {...props}>
			<path
				fill="currentColor"
				d="M1.167 14a1.12 1.12 0 0 1-.817-.35 1.12 1.12 0 0 1-.35-.817V1.167C0 .856.117.583.35.35A1.12 1.12 0 0 1 1.167 0h11.666c.311 0 .584.117.817.35.233.233.35.506.35.817v11.666c0 .311-.117.584-.35.817a1.12 1.12 0 0 1-.817.35H1.167Zm0-1.167h11.666V1.167H1.167v11.666Zm1.672-1.886h8.342c.11 0 .192-.052.248-.155a.292.292 0 0 0-.015-.311L9.139 7.447a.294.294 0 0 0-.233-.116.294.294 0 0 0-.234.116L6.34 10.461 4.764 8.303a.294.294 0 0 0-.233-.117.294.294 0 0 0-.234.117L2.625 10.48c-.078.103-.09.207-.034.31.055.104.138.156.248.156Z"
			/>
		</svg>
	);
}
